import clone from "@npm/clone";
import cartService from "../services/cart";
import orderService from "../services/order";
import chargeableBtls from "../utils/chargeableBtls";

const initialCart = {
  comment: "",
  lines: [],
  supplies: []
};

export default {
  namespaced: true,
  state: {
    cart: clone(initialCart)
  },
  mutations: {
    setCart(state, cart) {
      state.cart = cart;
    },
    resetCart(state) {
      state.cart = clone(initialCart);
    }
  },
  actions: {
    getCart({ commit }) {
      cartService.get()
        .then(({ data: cart }) => commit("setCart", cart));
    },
    addToCart({ state, dispatch }, newLine) {
      const cart = clone(state.cart);
      const line = cart.lines.find(line => line.product_id === newLine.product_id);

      if (line) {
        line.quantity += newLine.quantity;
      } else {
        cart.lines = [...cart.lines, newLine];
      }

      return dispatch("saveCart", cart);
    },
    removeFromCart({ state, dispatch }, product_id) {
      const cart = clone(state.cart);

      cart.lines = cart.lines.filter(line => line.product_id !== product_id);

      if (cart.lines.length === 0) {
        cart.comment = "";
      }

      return dispatch("saveCart", cart);
    },
    updateComment({ state, dispatch }, comment) {
      const cart = clone(state.cart);

      cart.comment = comment;

      return dispatch("saveCart", cart);
    },
    modifyQuantity({ state, dispatch }, { product_id, quantity }) {
      const cart = clone(state.cart);
      const line = cart.lines.find(line => line.product_id === product_id);

      if (line) {
        line.quantity = quantity;
      }

      return dispatch("saveCart", cart);
    },
    saveCart({ commit }, { comment, lines }) {
      return cartService.update({
        comment,
        lines: lines.map(({ product_id, quantity }) => ({
          product_id,
          quantity
        }))
      }).then(({ data: cart }) => commit("setCart", cart));
    },
    order({ commit }, { delivery_address_id }) {
      return orderService.post({ delivery_address_id })
        .then(() => commit("resetCart"));
    },
    reorder({ dispatch }, lines) {
      return dispatch("saveCart", {
        lines: lines.map(line => ({
          ...line,
          quantity: line.quantity + line.freeBtls
        })),
        comment: ""
      });
    }
  },
  getters: {
    lineCount: state => state.cart.lines.length,
    totalPrice: state => state.cart.lines.reduce((total, line) => total + line.price * chargeableBtls(line), 0),
    totalChargeableBtls: state => state.cart.lines.reduce((total, line) => total + chargeableBtls(line), 0),
    totalFreeBtls: state => state.cart.lines.reduce((total, line) => total + line.quantity - chargeableBtls(line), 0)
  }
};
